/**
 * @file Grid布局高层抽象 - 详情页
 * @author Ice(chenzhouji@baidu.com)
 * @modify zhangzhe(zhangzhe@baidu.com)
 */

import React from 'react';
import _ from 'lodash';
import {Row, Col} from 'acud';
import PropTypes from 'prop-types';

import {DU_PREFIX} from '../../_common/constants';
import './index.less';

const CLS_PREFIX = `${DU_PREFIX}-gridview`;

export interface GridViewItem {
    key: string;
    label: string;
    content: any;
}

export interface GridViewProps {
    labelWidth?: number;
    colCount?: number;
    withColon?: boolean;
    items: GridViewItem[];
    prefixCls?: string;
    color?: string;
}

const GridView: React.FunctionComponent<GridViewProps> = props => {
    const {withColon, labelWidth, items, colCount, prefixCls, color} = props;
    const prefixGridViewCls = prefixCls ? `${prefixCls}-gridview` : CLS_PREFIX;
    const width = 24 / (colCount as number);
    _.remove(items, _.isNil); // 删除为空的项
    const rows = _.chunk(items, colCount);

    return (
        <div className={prefixGridViewCls}>
            {_.map(rows, (cols, key) => {
                const colums = _.map(cols, (col, index) => (
                    <Col
                        span={width}
                        key={col.key || index}
                        className={`${prefixGridViewCls}-col-${col.key || index}`}
                    >
                        <div
                            className={`${prefixGridViewCls}-row-label ${prefixGridViewCls}-row-label-${index}`}
                            style={{width: labelWidth}}
                        >
                            {col.label}{withColon ? ':' : ''}
                        </div>
                        <div
                            className={`${prefixGridViewCls}-row-content`}
                            style={{marginLeft: labelWidth, color: color}}
                        >
                            {col.content}
                        </div>
                    </Col>
                ));
                return <Row className={`${prefixGridViewCls}-row`} key={key}>{colums}</Row>;
            })}
        </div>
    );
};

GridView.defaultProps = {
    labelWidth: 100, // label宽度
    colCount: 2, // 每行几列
    withColon: true, // 是否显示冒号
    items: []
};

GridView.propTypes = {
    labelWidth: PropTypes.number,
    colCount: PropTypes.number,
    withColon: PropTypes.bool,
    items: PropTypes.array.isRequired
};

export default GridView;